"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InputLabel_1 = require("./InputLabel");
exports.default = InputLabel_1.default;
//# sourceMappingURL=index.js.map